import { Component } from "macguffin"
import GameMode from "game/modes"
import GameModeGroup from "game/modes/GameModeGroup"
import Timings from "game/Timings"

import BackgroundImage from "utils/BackgroundImage"

const { TAKEOFF_DELAY, TAKEOFF_DURATION } = Timings
const earthHiddenGroup = new GameModeGroup([GameMode.PICK, GameMode.FREESPIN])

const fadeInAnimation = "fadeIn 5s 5s forwards"
const fadeOutAnimation = "fadeOut 5s forwards"
const cloudMotionAnimation = "scrollBackground 1s infinite linear"

const earthBackgroundStyle = {
    width: "100vw",
    height: "100vh",
    backgroundSize: "100vw auto",
    backgroundPosition: "bottom left"
}

const earthCloudStyle = {
    width: "100vw",
    height: "100vh",
    backgroundSize: "cover",
    backgroundPosition: "top left"
}

const earthCloudMotionStyle = {
    width: "100%",
    height: "100%",
    backgroundSize: "auto",
    backgroundRepeat: "repeat"
}

export default class EarthBackground extends Component {

    componentWillMount() {
        const { props } = this

        if (props.currentGameMode === GameMode.PICK && !props.currentPickStageIndex) {
            this.setState({
                groundStyle: { visibility: "hidden" },
                skyStyle: { opacity: 1 }
            })
        } else {
            this.setState({
                groundStyle: { visibility: "visible" },
                skyStyle: { visibility: "hidden" }
            })
        }
    }

    componentWillReceiveProps(nextProps) {
        const currentProps = this.props

        if (nextProps.currentGameMode !== currentProps.currentGameMode) {
            switch(nextProps.currentGameMode) {
                case GameMode.BONUS_INTRO:
                    this.setState({
                        groundStyle: {
                            transform: "translateY(100%)",
                            visibility: "visible"
                        },
                        skyStyle: {
                            animation: fadeInAnimation,
                            visibility: "visible"
                        },
                        cloudMotionStyle: {
                            animation: cloudMotionAnimation
                        }
                    })
                    break
                case GameMode.PICK:
                    if (currentProps.currentGameMode === GameMode.RESUME && !currentProps.currentPickStageIndex) {
                        this.setState({
                            groundStyle: {
                                visibility: "hidden"
                            },
                            skyStyle: {
                                animation: fadeInAnimation,
                                visibility: "visible"
                            },
                            cloudMotionStyle: {
                                animation: cloudMotionAnimation
                            }
                        })
                    }
                    break
                case GameMode.FREESPIN:
                    this.setState({
                        groundStyle: {
                            visibility: "hidden"
                        },
                        skyStyle: {
                            animation: fadeOutAnimation,
                            visibility: "visible"
                        }
                    })
                    break
                case GameMode.MARS_INTRO:
                    this.setState({
                        groundStyle: {
                            visibility: "hidden"
                        },
                        skyStyle: {
                            visibility: "hidden"
                        },
                        cloudMotionStyle: {}
                    })
                    break
                case GameMode.MAIN:
                    this.setState({
                        groundStyle: {
                            visibility: "visible"
                        },
                        skyStyle: {
                            visibility: "hidden"
                        },
                        cloudMotionStyle: {}
                    })
                    break
            }
        }
    }

    render() {
        const { props, state } = this
        const { globalPaused } = props
        const { groundStyle, skyStyle, cloudMotionStyle } = state

        const animationStyle = { animationPlayState: globalPaused ? "paused" : "running" }

        return <div key="earthBackgroundContainer" className="earthBackgroundContainer">
            <div className="earthSkyContainer" style={skyStyle}>
                <div className="earthSky">
                    <BackgroundImage assetName="earthCloudMotion" style={{
                        ...earthCloudMotionStyle,
                        ...cloudMotionStyle,
                        ...animationStyle
                    }}/>
                </div>
            </div>
            <div key="earthBackgroundContainer" className="earthBackground" style={groundStyle}>
                <BackgroundImage key="earthClouds" assetName="earthClouds" style={earthCloudStyle}/>
                <BackgroundImage key="earthBackground" assetName="earthBackground" style={earthBackgroundStyle}/>
            </div>
        </div>
    }
}
